import { useEffect, useState } from 'react';

// The part of the screen the page can use, and how much of the bottom the
// on-screen keyboard covers. iOS keeps the layout viewport full height when
// the keyboard opens, so position:fixed bottom bars end up behind it; the
// visual viewport is what is actually visible.
export interface ViewportBox {
    height: number;
    keyboardInset: number;
}

export function readViewport(
    win: Pick<Window, 'innerHeight' | 'visualViewport'>
): ViewportBox {
    const vv = win.visualViewport;
    if (!vv) return { height: win.innerHeight, keyboardInset: 0 };
    return {
        height: vv.height,
        keyboardInset: Math.max(
            0,
            Math.round(win.innerHeight - vv.height - vv.offsetTop)
        ),
    };
}

export function useVisualViewport(): ViewportBox {
    const [box, setBox] = useState<ViewportBox>(() => readViewport(window));
    useEffect(() => {
        const update = () => setBox(readViewport(window));
        const vv = window.visualViewport;
        vv?.addEventListener('resize', update);
        vv?.addEventListener('scroll', update);
        window.addEventListener('resize', update);
        return () => {
            vv?.removeEventListener('resize', update);
            vv?.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
        };
    }, []);
    return box;
}
